import r from "./index.es144.js";
import m from "./index.es267.js";
const p = m.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, o, n, i, s, u) {
      const t = [e + "=" + encodeURIComponent(o)];
      r.isNumber(n) && t.push("expires=" + new Date(n).toGMTString()), r.isString(i) && t.push("path=" + i), r.isString(s) && t.push("domain=" + s), u === !0 && t.push("secure"), document.cookie = t.join("; ");
    },
    read(e) {
      const o = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return o ? decodeURIComponent(o[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
export {
  p as default
};
//# sourceMappingURL=index.es420.js.map
